import { Component, OnInit, AfterViewInit } from "@angular/core";
import {
    CclBuilderService,
    CclCustomSiteModel,
    CclNavbarFooterService,
    CclMessageService
} from "certain-common-library";
import { SharedService } from "../../../../../modules/shared/services/shared.service";
import { CatalogService } from "../../../../../modules/shared/services/catalog.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { Subscription } from "rxjs";
import { Router, ActivatedRoute } from "@angular/router";
import { UnsavedChangesDeactivate } from "../../../can-deactivate";
import { cloneDeep } from "lodash";

@Component({
    selector: "app-html-page",
    templateUrl: "./html-page.view.html",
    styleUrls: []
})
export class HtmlPageView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit {
    subscription: Subscription;
    baseUrl: string;
    htmlConfigObj: any;
    htmlConfig: any;
    constructor(
        public sharedService: SharedService,
        public builderService: CclBuilderService,
        private navbarFooterService: CclNavbarFooterService,
        private messageService: CclMessageService,
        private _flashMessagesService: FlashMessagesService,
        private router: Router,
        private catalogService: CatalogService,
        private activatedRoute: ActivatedRoute
    ) {
        super(sharedService);
        if (this.activatedRoute.routeConfig.path === "html-top") {
            this.baseUrl = "top";
        } else if (this.activatedRoute.routeConfig.path === "html-bottom") {
            this.baseUrl = "bottom";
        }
        this.subscription = this.messageService.getMessage().subscribe((message) => this.saveHtmlConfig(message));
    }

    ngOnInit() {
        this.sharedService.currentLayoutSection = "html-" + this.baseUrl;
        this.htmlConfigObj = this.sharedService.configs[this.sharedService.configTypes.HTML[this.baseUrl]];
        this.builderService.setElementTypes(["image", "text", "spacer"]);
        this.builderService.currentPageKey = "landing";
        this.builderService.drawerSize = "mid";
        if (this.htmlConfigObj == null || this.htmlConfigObj.id == null) {
            this.builderService.currentSite = <CclCustomSiteModel>(
                this.builderService.createBasicSiteNew("html").formPayload
            );
            this.htmlConfig = { isEnabled: false, template: this.builderService.currentSite };
            this.htmlConfigObj = {
                id: null,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: null,
                configType: this.sharedService.configTypes.HTML[this.baseUrl]
            };
        } else {
            this.htmlConfig = JSON.parse(this.htmlConfigObj.config);
            this.builderService.currentSite = this.htmlConfig.template;
        }

        // For checking unsaved data
        this.sharedService.originalData = cloneDeep(this.htmlConfig);
        this.sharedService.changedData = this.htmlConfig;
    }

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            if (this.activatedRoute.routeConfig.path === "html-top") {
                this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Define Tabs";
            } else if (this.activatedRoute.routeConfig.path === "html-bottom") {
                this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Define Footer";
            }
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-html";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-next-html";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    ngOnDestroy(): void {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    saveHtmlConfig(message) {
        if (message.text == "save-html" || message.text == "save-next-html") {
            this.htmlConfig.template = this.builderService.currentSite;
            this.htmlConfigObj.config = JSON.stringify(this.htmlConfig);
            this.catalogService.saveSetupConfig(this.htmlConfigObj).subscribe((resp) => {
                // For checking unsaved data
                this.sharedService.originalData = cloneDeep(this.htmlConfig);
                this.sharedService.changedData = this.htmlConfig;

                this.htmlConfigObj = resp.body["sessionCatalogSetupConfigDTO"];
                this.sharedService.configs[this.sharedService.configTypes.HTML[this.baseUrl]] = this.htmlConfigObj;
                this._flashMessagesService.show("Html saved successfully.", {
                    cssClass: "alert-success"
                });
                if (message.text == "save-next-html") {
                    if (this.baseUrl == "top") {
                        this.sharedService.currentLayoutSection = "tabs";
                        this.sharedService.catalogNavigateHelper("admin", "catalog/layout/tabs");
                    } else {
                        this.sharedService.currentLayoutSection = "footer";
                        this.sharedService.catalogNavigateHelper("admin", "catalog/layout/footer");
                    }
                }
            });
        }
    }
    toggleHTMLEnable(e) {
        this.htmlConfig.isEnabled = !this.htmlConfig.isEnabled;
    }
}
